export default __webpack_public_path__ + "static/fa-regular-400-a3b4cd30799e10f5fbc2e220fd2f7098.ttf";